import _slicedToArray from "/Users/n8/Development/NFT My Monstera/code/.build/websites/moodymonsteras.com/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/Users/n8/Development/NFT My Monstera/code/.build/websites/moodymonsteras.com/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/n8/Development/NFT My Monstera/code/.build/websites/moodymonsteras.com/node_modules/@babel/runtime/regenerator/index.js";
import { Contract } from '@ethersproject/contracts';
var ABI = ['function aggregate(tuple(address target, bytes callData)[] calls) view returns (uint256 blockNumber, bytes[] returnData)'];
export function multicall(_x, _x2, _x3, _x4) {
  return _multicall.apply(this, arguments);
}

function _multicall() {
  _multicall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(provider, address, blockNumber, requests) {
    var _a, contract, _yield$contract$aggre, _yield$contract$aggre2, results, state, i, _requests$i, _address, data, result, stateForAddress;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(requests.length === 0)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", {});

          case 2:
            contract = new Contract(address, ABI, provider);
            _context.next = 5;
            return contract.aggregate(requests.map(function (_ref) {
              var address = _ref.address,
                  data = _ref.data;
              return [address, data];
            }), {
              blockTag: blockNumber
            });

          case 5:
            _yield$contract$aggre = _context.sent;
            _yield$contract$aggre2 = _slicedToArray(_yield$contract$aggre, 2);
            results = _yield$contract$aggre2[1];
            state = {};

            for (i = 0; i < requests.length; i++) {
              _requests$i = requests[i], _address = _requests$i.address, data = _requests$i.data;
              result = results[i];
              stateForAddress = (_a = state[_address]) !== null && _a !== void 0 ? _a : {};
              stateForAddress[data] = result;
              state[_address] = stateForAddress;
            }

            return _context.abrupt("return", state);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _multicall.apply(this, arguments);
}